<template>
  <div>
    <d-table
      :data_object="data_object"
      :getFreshData="true"
      :alwaysUpdate="true"
      :hasSearch="true"
      :searchLen="3"
      :defaultModel="defaultModel"
      :beforeAddData="beforeAddData"
      addButtonCaption=""
      :loading="loading"
      :fields_excluded="fields_excluded"
      :editRow="true"
      :beforeSave="beforeSave"
    />
    <v-alert v-if="successMessage" type="success">
      {{ successMessage }}
    </v-alert>
    <v-alert v-if="errorMessage" type="error">
      {{ errorMessage }}
    </v-alert>
  </div>
</template>

<script>
import axios from "axios";

import DTable from "../../components/Table";
import * as fun from "../../plugins/common";

export default {
  name: "Users",
  components: { DTable },
  data: () => ({
    fields_excluded: [],
    editable: ["password"],
    successMessage: "",
    errorMessage: "",
    data_object: {
      object_name: "v_users",
      // db_name: "master",
      // portal_id: true,
      all_records: true,
      table_title: "Users",
      qry: { type: { $ne: "customer" } },
      // qry: {
      //   portal_id: JSON.parse(
      //     localStorage.getItem("portalData")
      //   ).portalId.toString(),
      // },
    },

    users: [],
    dataLoaded: false,
    defaultModel: {
      roles: [],
    },

    loading: false,
    rolesLoading: false,
    allRoles: [],
    portalsLoading: false,
    allPortals: [],
    // link: {
    //   field: "email",
    // },
  }),

  mounted() {
    // this.fetchUsers();
    // this.defaultModel.portal_id = this.data_object.qry.portal_id;
    var that = this;

    // this.$root.$on("tableItemChanged", (t) => {
    //   if (!t.tbl.tableName && !t.tbl.objectName) {
    //     return;
    //   }

    //   var curRec = t.tbl.table.filter((r) => {
    //     return r._id == t.item._id;
    //   })[0];
    // });
  },

  methods: {
    // beforeAddData(model) {
    //   this.createUser(model);
    //   return true;
    // },
    // linkClick: function(item) {
    //   var link = item.type == "customer" ? "customer" : "settings/" + item.type;

    //   var tab = {
    //     link: "/" + link,
    //     text: fun.capitalize(item.type),
    //   };

    //   this.$root.addResentTab(tab);
    // },
    beforeSave(r, tbl) {
      // console.log(tbl);
      tbl.data_object.object_name = r.type;
    },
    createUser(model) {
      this.loading = true;
      // this.userForm.data.portal_id = this.data_object.qry.portal_id;
      axios
        .post(this.serverURL + "/create_user", model, {
          withCredentials: true,
        })
        .then((response) => {
          this.successMessage = "User created";
          // this.close();
          // this.fetchUsers();
        })
        .catch((reason) => {
          this.errorMessage = "User cannot be created :" + reason;
          // errorsHandler(reason);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
